export default (payload) => ({
	type: 'UPDATE_FEEDBACK',
	payload,
})
